@if (hasDeltas()) {
  <div class="ai-comparison" *transloco="let t; prefix: 'ai-assistant'">
    @if (title()) {
      <div class="ai-comparison__title">{{ title() }}</div>
    }
    <div class="ai-comparison__header">
      <div class="ai-comparison__metric-col">{{ t('comparison-metric') }}</div>
      <div class="ai-comparison__value-col">{{ sliceALabel() }}</div>
      <div class="ai-comparison__value-col">{{ sliceBLabel() }}</div>
      <div class="ai-comparison__delta-col">{{ t('comparison-change') }}</div>
    </div>
    @for (d of deltas(); track $index) {
      <div class="ai-comparison__row">
        <div class="ai-comparison__metric-col">{{ d.metric }}</div>
        <div class="ai-comparison__value-col">{{ formatNumber(d.sliceA) }}</div>
        <div class="ai-comparison__value-col">{{ formatNumber(d.sliceB) }}</div>
        <div class="ai-comparison__delta-col">
          <span class="ai-comparison__delta" [class]="deltaClass(d)">
            {{ formatDelta(d) }}
          </span>
        </div>
      </div>
    }
  </div>
}
